module.exports = __webpack_public_path__ + "img/logo-dark.ab519d9f.png";